/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-06-17",
    versionChannel: "nightly",
    buildDate: "2023-06-17T00:19:30.791Z",
    commitHash: "5e6366d14a18994431dc4de1d3665b765371b129",
};
